var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.8672 1.4258-.8789.8984L15.6641 5H2.5v1.25h13.1641l-2.6758 2.6758.8789.8984 4.1992-4.1992-4.1992-4.1992Zm-7.7344 8.75L1.9336 14.375l4.1992 4.1992.879-.8984L4.3358 15H17.5v-1.25H4.336l2.6757-2.6758-.8789-.8984Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExchange);
export default ForwardRef;